var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 4.66666H15.9998C9.74061 4.66666 4.6665 9.74076 4.6665 16V48C4.6665 54.2592 9.74061 59.3333 15.9998 59.3333H47.9998C54.2591 59.3333 59.3332 54.2592 59.3332 48V16C59.3332 9.74076 54.2591 4.66666 47.9998 4.66666Z",
    stroke: "#83C8D7",
    strokeWidth: 2.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3153 20.2686L30.344 26.2972M24.3153 41.1245V20.2686V41.1245ZM24.3153 20.2686L18.2866 26.2972L24.3153 20.2686Z",
    stroke: "#83C8D7",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3047 43.7318L33.2759 37.7029M39.3047 22.8756V43.7318V22.8756ZM39.3047 43.7318L45.3332 37.7029L39.3047 43.7318Z",
    stroke: "#83C8D7",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.54da43f9704586d39fcd3569e4dbe1f8.svg";
export { ForwardRef as ReactComponent };